module.exports = __webpack_public_path__ + "img/icon.c337e956.svg";